// extracted by mini-css-extract-plugin
export default {"screen-content":"UserEditScreen_screen-content__xd-5V"};